import React from 'react';
import { NotificationSkeleton } from './NotificationSkeleton';
import { Notification } from './Notification';
import { ErrorState, Flex, InfiniteScrollableView } from '@zeal/web-ui';
import { NotificationsEmpty } from './NotificationsEmpty';
import { NotificationsContainer } from '../StyledComponents';
import useNotificationsList from './useNotificationsList';

export function NotificationsList({
	setIsNotificationsOpen,
}: {
	setIsNotificationsOpen: (value: boolean) => void;
}) {
	const {
		notifications,
		isNotificationsLoading,
		hasNextPage,
		fetchNextPage,
		isFetchingNextPage,
		isNotificationsError,
	} = useNotificationsList();

	if (isNotificationsError) {
		return (
			<NotificationsContainer isColumn>
				<Flex className="w-full h-full" align="center" justify="center">
					<ErrorState isLoading={false} />
				</Flex>
			</NotificationsContainer>
		);
	}

	return (
		<NotificationsContainer isColumn>
			<InfiniteScrollableView
				allRows={notifications}
				fetchNextPage={fetchNextPage}
				hasNextPage={hasNextPage}
				isFetchingNextPage={isFetchingNextPage}
				isLoading={isNotificationsLoading}
				loadingItem={<NotificationSkeleton />}
				renderItem={(notification) => (
					<Notification
						key={notification.uuid}
						setIsNotificationsOpen={setIsNotificationsOpen}
						{...notification}
					/>
				)}
				emptyContent={<NotificationsEmpty />}
				containerProps={{
					maxHeight: '100%',
				}}
			/>
		</NotificationsContainer>
	);
}
